import { AlertTriangleIcon } from '@langchain/untitled-ui-icons';

import { Link, useLocation } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { appHubIndexPath, appPromptsIndexPath } from '@/utils/constants';

export function Error({ children }: { children: React.ReactNode }) {
  const organizationId = useOrganizationId();
  const path = useLocation().pathname;
  const isHub = path.split('/')[1] === appHubIndexPath;
  return (
    <div className="my-auto flex h-full flex-1 items-center justify-center">
      <div className="flex w-[352px] flex-col items-center justify-start gap-6">
        <div className="flex flex-col items-center justify-start gap-4 self-stretch">
          <div className="inline-flex h-[80px] w-[152px] items-center justify-center">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-[36px] bg-slate-500 bg-opacity-30 p-3">
              <AlertTriangleIcon className="relative flex h-6 w-6 flex-col items-start justify-start" />
            </div>
          </div>
          <div className="flex flex-col items-center justify-start gap-1">
            <div className="self-stretch text-center text-base font-semibold leading-normal text-ls-black">
              Oops! An error occurred
            </div>
            <div className="grow text-center text-sm font-normal leading-tight text-tertiary">
              {children}
            </div>
          </div>
        </div>
        <div className="flex items-start justify-center gap-2">
          <Link
            to={`/${isHub ? appHubIndexPath : appPromptsIndexPath}${
              organizationId ? `?organizationId=${organizationId}` : ''
            }`}
          >
            <a className="flex items-center justify-center gap-2 rounded-md border border-brand bg-brand-green-500 px-4 py-2.5">
              <div className="text-sm font-medium leading-tight text-white">
                Go home
              </div>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
